/**
 * Formulario de nueva asignación de reponedor a almacén
 */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

import { StateContext } from "../../../components/context/StateProvider";
import UsuariosService from "../../../services/usuarios.service";
import ReponedoresService from "../api/reponedores.api";
import Toasts from "../../../components/notificacion/Toasts";
import { ReponedorForm } from "../components";

// DECISION: Esta vista es intencionalmente delgada. Solo orquesta ReponedorForm
// y gestiona la navegación y los toasts. Toda la lógica del formulario
// (validaciones, llamadas al servicio) vive en ReponedorForm.
// Maneja tanto creación (sin :id) como edición (con :id en la URL).
const NuevaAsignacion = () => {
    const { state, updateState, recargarAsignacionesReponedores } = useContext(StateContext);
    const navigate = useNavigate();
    const { id } = useParams();

    const [usuarios, setUsuarios] = useState([]);
    const [editingReponedor, setEditingReponedor] = useState(null);
    const [loading, setLoading] = useState(!!id); // Solo loading si estamos editando

    useEffect(() => {
        cargarDatos();
    }, [id]);

    const cargarDatos = async () => {
        try {
            const usuariosData = await UsuariosService.listarUsuariosMap();
            setUsuarios(usuariosData);

            // Si hay id en la URL, estamos editando: cargar el reponedor
            if (id) {
                const reponedores = await ReponedoresService.list();
                const reponedor = reponedores.find(r => r.id === Number(id));

                if (!reponedor) {
                    const toast = Toasts.generateToast('Asignación no encontrada', 'error');
                    updateState({ toasts: [...state.toasts, toast] });
                    navegarAReponedores();
                    return;
                }

                setEditingReponedor(reponedor);
            }

            setLoading(false);
        } catch (error) {
            const toast = Toasts.generateToast(error.message, 'error');
            updateState({ toasts: [...state.toasts, toast] });
            setLoading(false);
        }
    };

    const navegarAReponedores = () => {
        navigate('/reponedores');
    };

    const handleSave = async (_resultado, action) => {
        const mensaje = action === 'created'
            ? 'Asignación creada correctamente'
            : 'Asignación actualizada correctamente';

        const toast = Toasts.generateToast(mensaje, 'success');
        updateState({ toasts: [...state.toasts, toast] });

        // Recargar asignaciones en el contexto global
        if (recargarAsignacionesReponedores) {
            await recargarAsignacionesReponedores();
        }

        navegarAReponedores();
    };

    const handleError = (mensajeError) => {
        const toast = Toasts.generateToast(mensajeError, 'error');
        updateState({ toasts: [...state.toasts, toast] });
    };

    const handleCancel = () => {
        navegarAReponedores();
    };

    const almacenesOptions = state.almacenes?.map(a => ({
        value: a.CODIGO,
        label: `${a.CODIGO} - ${a.NOMBRE}`
    })) || [];

    const usuariosOptions = usuarios.map(u => ({
        value: u.id,
        label: u.nombre
    }));

    if (loading) {
        return (
            <Box
                id="nueva-asignacion"
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "400px",
                }}
            >
                <Box sx={{ textAlign: "center" }}>
                    <CircularProgress sx={{ color: "#cc071e", mb: 2 }} />
                    <Typography sx={{ color: "#6c757d" }}>Cargando...</Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box id="nueva-asignacion" sx={{ width: "100%" }}>
            <ReponedorForm
                reponedor={editingReponedor}
                almacenesOptions={almacenesOptions}
                usuariosOptions={usuariosOptions}
                onSave={handleSave}
                onError={handleError}
                onCancel={handleCancel}
            />
        </Box>
    );
};

export default NuevaAsignacion;
